import './App.css';

import { Route, Routes } from "react-router-dom"
import Home from "./pages/Home"

import 'bootstrap/dist/css/bootstrap.min.css';
import Tract from './pages/Tract';
import MovieProx from './pages/Movieprox';
import Me from './pages/Me'
import Contact from './pages/Contact';
import CrewPrivacy from './pages/CrewPrivacy';

function App() {
  return (
    <div className="App">
      <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/home" element={<Home/>} />

            <Route path="/movieprox" element={<MovieProx/>} />
            <Route path="/tract" element={<Tract/>} />
            <Route path="/me" element={<Me/>} />
            <Route path="/contact" element={<Contact/>} />
            <Route path="/crew-privacy" element={<CrewPrivacy/>} />


          </Routes>
    </div>
  );
}

export default App;
